import { render, staticRenderFns } from "./informedConsentAgreement.vue?vue&type=template&id=6900dd53&scoped=true&"
import script from "./informedConsentAgreement.vue?vue&type=script&lang=js&"
export * from "./informedConsentAgreement.vue?vue&type=script&lang=js&"
import style0 from "./informedConsentAgreement.vue?vue&type=style&index=0&id=6900dd53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6900dd53",
  null
  
)

export default component.exports